import MonestLoader from './monest-loader';

export default MonestLoader;
